import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface Invoices{
  id: number,
  price: number,
  wage?: number,
  tax?: number,
  discount?: number,
  note?: string,
  create_date: string,
  update_date?: string,
  ip?: string,
  user_agent?: string,
  status: string,
}

export interface InvoicePay {
  url: Location
}

export const invoiceApi = createApi({
  reducerPath: 'invoiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['invoice'],

  endpoints: (builder) => ({
    getAllInvoices: builder.query<Invoices[],void>({
      query: () => 'invoice/view_all',
      providesTags: ['invoice']
    }),
    getInvoice: builder.query<any,any>({
      query: (id) => `invoice/${id}`,
      providesTags: ['invoice']
    }),
    createByPackage: builder.mutation<InvoicePay,number>({
      query: (id) => ({
        url: `invoice/createByPackage/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['invoice']
    }),
    payOnlineInvoice: builder.mutation<InvoicePay,number>({
      query: (id) => ({
        url: `transaction/invoiceOnline/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['invoice']
    })
  }),
})

export const { useGetAllInvoicesQuery, useCreateByPackageMutation, useGetInvoiceQuery, usePayOnlineInvoiceMutation } = invoiceApi